import OpeningApi from './_openingApi';
import httpClient from '@/apis/base/httpclient';

class OpeningAccountEntryAPI extends OpeningApi {
  constructor() {
    super();
  }
  controllerName = 'OpeningAccountEntrys';

  /**
   * Lấy dữ liệu danh sách
   */
  getList(payload) {
    let request = {
      url: this.getAPIUrl() + '/listAccountBalance',
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Xóa số dư tài khoản
   * Created by NNkiem 22.09.2022
   */
  deleteAccountBlanace(param) {
    let request = {
      url: this.getAPIUrl() + '/AccountBlanace',
      data: param,
    };

    return httpClient.deleteAsync(request);
  }
  /**
   * Lấy dữ liệu database thông tư cũ (thông tư 107)
   * @param {*} param
   * @returns
   * NVTUAN1 02.08.2024
   */
  getDatabaseOldCircular() {
    let request = {
      url: this.getAPIUrl() + '/DatabaseOldCircular',
    };
    return httpClient.getAsync(request);
  }

  /**
   * Kiểm tra kết chuyển
   * @param {*} param
   * @returns
   */
  checkOpeningAccountTransferV3(param) {
    let url = window._apis.ProxyForwarder + '/' + this.controllerName;
    let request = {
      url: [url, 'OpeningAccountTransfer'].join('/') + `?app=v3`,
      data: param,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Kiểm tra kết chuyển khi lấy số dư đầu năm từ chế độ cũ
   * @param {*} param
   * @returns
   * NVTUAN1 02.08.2024
   */
  checkOpeningAccountTransferOldCircular(param) {
    let request = {
      url: this.getAPIUrl(true) + '/OpeningAccountTransferOldCircular',
      data: param,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy liệu cho màn list detail trừ tab vthh dùng entity khác
   * nvtoan2 16/09/2022
   */
  getAccountBalanceListDetail(param) {
    let request = {
      url: this.getAPIUrl() + '/AccountBalanceListDetail',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy thông tin detail
   * pthai - 31/07/2023
   */
  getListDetail(param) {
    let request = {
      url: this.getAPIUrl() + '/ListDetail',
      data: param,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Add and Update multiple
   * bnanh 23.06.2022
   */
  addAndUpdateData(param) {
    let request = {
      url: this.getAPIUrl() + '/AccountBalanceDetail',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu chi tiết theo từng tài khoản
   * pthai 26/09/2022
   */
  getOPBalanceListDetail(param) {
    let request = {
      url: this.getAPIUrl() + '/OPBalanceDetail',
      data: param.param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Gọi API lấy dữ liệu từ QLTS
   * NBTIN 09.02.2023
   */
  getDataInitBalanceQLTS(param) {
    let request = {
      url: this.getAPIUrl() + `/DataInitBalanceQLTS`,
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * gọi api lấy dữ liệu số dư tk cho MS03-SDKP/ĐTDV
   * @param {*} param
   * @returns
   */
  getAccountBalanceListDetailForReport(param) {
    let request = {
      url: this.getAPIUrl() + `/AccountBalanceListDetailForReport`,
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Kiểm tra kết chuyển
   * @param {*} param
   * @returns
   */
  getDataOpenning(param) {
    let request = {url: this.getAPIUrl() + '/GetDataOpenning', data: param};

    return httpClient.getAsync(request);
  }
  /**
   * Lấy dữ liệu database thông tư 107
   * @param {*} param
   * @returns
   * TPNAM 26/09/2023
   */
  getDatabaseTT107(param) {
    let request = {
      url: this.getAPIUrl() + '/DatabaseTT107',
    };
    return httpClient.getAsync(request);
  }
}

export default new OpeningAccountEntryAPI();
